import {
	AccelerationUnit,
	NoneType,
	OverpressureUnit,
	VelocityUnit,
	VibrationSubType,
} from "@soft-db/data-formatter";
import { createPluginOptions } from "../create-plugin-options";

export const defaultEventWaveformDataOptions = createPluginOptions()({
	vibrationType: "velocity" as VibrationSubType,
	unit: "mm/s" as AccelerationUnit | VelocityUnit | NoneType,
	oplUnit: "Pa" as OverpressureUnit,
});

export type EventWaveformDataOptions = typeof defaultEventWaveformDataOptions;
